import { StyledTooltip } from '@common/components/StyledTooltip';
import { Box, MenuItem } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { openLink } from '@modules/common/helpers/browser';
import { isAfter, timeAgo } from '@modules/common/helpers/date';
import { InsightsIcon } from '@/assets/icons';

type Props = {
  url?: string;
  expirationDate?: Date | null;
};

export const DashboardMenuItem = ({ url, expirationDate }: Props) => {
  const { t } = useTranslation('interface');
  const dashboardUrlExpirationDate = expirationDate;

  const expired = useMemo(
    () => !!dashboardUrlExpirationDate && isAfter(dashboardUrlExpirationDate),
    [dashboardUrlExpirationDate],
  );

  const tooltip = useMemo(() => {
    if (!dashboardUrlExpirationDate) {
      return;
    }

    if (isAfter(dashboardUrlExpirationDate)) {
      return t('simulation.run_card.dashboard_button.expired_tooltip');
    }

    return t('simulation.run_card.dashboard_button.expire_tooltip', {
      date: timeAgo(dashboardUrlExpirationDate),
    });
  }, [dashboardUrlExpirationDate, t]);

  const onClick = useCallback(async () => {
    if (url) openLink(url);
  }, [url]);

  const content = (
    <MenuItem onClick={onClick} disabled={!url || expired}>
      <InsightsIcon />
      {t('simulation.run_card.dashboard_button.label')}
    </MenuItem>
  );

  if (tooltip) {
    return (
      <StyledTooltip title={tooltip} placement='top'>
        <Box>{content}</Box>
      </StyledTooltip>
    );
  }

  return content;
};
